<template>
  <div class="callback">
    Callback
  </div>
</template>

<script>
export default {
  name: 'Callback',
  mounted() {
  }
}
</script>
